export default __webpack_public_path__ + "static/media/refresh.77dc840b.svg";